module.exports = __webpack_public_path__ + "img/MTM2729-20H-模範天狼.c9a58724.png";